import institutionAPI from 'services/institutionAPI'

type Params = {
  roleId: string
}

export default async function getRoleOnCustomForm({ roleId }: Params) {
  const response = await institutionAPI({
    method: 'GET',
    url: `/citizen-portal/service/role/${roleId}`,
  })

  return response
}
